import { useSelector } from 'react-redux';

import { DEFAULT_UNITS_BY_PREFERRED_SYSTEM } from 'constants/unitOfMeasure';

import { usePreferredUnitSystem } from 'utils/measurement/hooks';

import MetaDataDisplayComponent from '../components/MetaDataDisplayComponent';
import {
  getDimensionalPrecision,
  getDisplayScale,
  getMetaData,
  getNativeUnits,
} from '../data/reducer';

const MetaDataDisplay = ({ isEnabled }: { isEnabled: boolean }) => {
  const displayScale = useSelector(getDisplayScale);
  const metaData = useSelector(getMetaData);
  const nativeUnits = useSelector(getNativeUnits);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);

  const { preferredUnitSystem } = usePreferredUnitSystem();
  const displayUnits = DEFAULT_UNITS_BY_PREFERRED_SYSTEM[preferredUnitSystem];

  return isEnabled ? (
    <MetaDataDisplayComponent
      displayScale={displayScale}
      displayUnits={displayUnits}
      metaData={metaData}
      nativeUnits={nativeUnits}
      dimensionalPrecision={dimensionalPrecision}
    />
  ) : null;
};

export default MetaDataDisplay;
